module.exports = __webpack_public_path__ + "static/media/default_avatar.65f44eb9.jpg";